import { Box, IconButton } from '@mui/material';
import { Check } from '@mui/icons-material';
import type { FC } from 'react';
import { LABEL_COLOR_PRESETS } from './labels-consts';
import type { LabelColorPreset } from './labels-types';

type LabelColorPickerProps = {
  selectedColor: LabelColorPreset;
  onColorSelect: (color: LabelColorPreset) => void;
};

export const LabelColorPicker: FC<LabelColorPickerProps> = ({ selectedColor, onColorSelect }) => {
  return (
    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
      {LABEL_COLOR_PRESETS.map((preset) => {
        const isSelected =
          preset.color === selectedColor.color && preset.backgroundColor === selectedColor.backgroundColor;

        return (
          <IconButton
            key={preset.color}
            onClick={() => onColorSelect(preset)}
            sx={{
              width: 16,
              height: 16,
              padding: 0,
              backgroundColor: preset.color,
              border: isSelected ? `1.5px solid black` : '1.5px solid transparent',
              '&:hover': {
                backgroundColor: preset.color,
              },
            }}
          >
            {isSelected && <Check sx={{ fontSize: 12, color: 'white' }} />}
          </IconButton>
        );
      })}
    </Box>
  );
};
